/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ language: NonNullable<unknown> }} Locale_Banner_SuggestInputs */



/**
* | output |
* | --- |
* | "OpenRift is also available in {language}, machine-translated and in beta." |
*
* @param {Locale_Banner_SuggestInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const locale_banner_suggest = /** @type {((inputs: Locale_Banner_SuggestInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Locale_Banner_SuggestInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`OpenRift gibt es auch auf ${i?.language}, maschinell übersetzt und in der Beta.`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`OpenRift est aussi disponible en ${i?.language}, traduit automatiquement et en bêta.`)
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ (`OpenRift 也提供${i?.language}版本，由机器翻译，目前处于测试阶段。`)
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ (`OpenRift 也提供${i?.language}版本，由機器翻譯，目前仍在測試階段。`)
	if (locale === "ko") return /** @type {LocalizedString} */ (`OpenRift는 ${i?.language}(으)로도 제공됩니다. 기계 번역된 베타 버전입니다.`)
	return /** @type {LocalizedString} */ (`OpenRift is also available in ${i?.language}, machine-translated and in beta.`)
});